// import { DtmfPlayer } from 'play-dtmf';
import { useSelector } from 'react-redux';
import toneSound from '~/assets/sounds/keypressTone.mp3';

export default function useDtmfSound() {
  // SELECTORS
  const disableKeypadTone = useSelector(
    state => state.system && state.system.disableKeypadTone
  );

  function setSoundDtmf() {
    // setSoundDtmf(key) {
    // const dtmfPlayer = new DtmfPlayer();
    // dtmfPlayer.play(key);
    // setTimeout(() => {
    //   dtmfPlayer.stop();
    //   dtmfPlayer.close();
    // }, 300);
    if (!disableKeypadTone) {
      const dtmf = new Audio(toneSound);
      dtmf.play();
    }
  }

  return setSoundDtmf;
}
